import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import axios from "axios";
import { connect } from "react-redux";
import { format } from "date-fns";
import { query_generate } from "./../../utilities/_query_generate";
import { relational_filter_list } from "./../../utilities/_filter_list_builder";
import { signOut } from "../../store/actions/authAction";
import TabNavs from "./components/tabNavs";
import { RiDeleteBin6Line } from "react-icons/ri"; // Import the delete icon
import { IconContext } from "react-icons";
import FilterElement from "./../layout/FilterElement";
import received_kyc_img from "./../../img/kyc/tabs/received_kyc_img.png";
import received_kyc_active_img from "./../../img/kyc/tabs/received_kyc_active_img.png";
import "./style.scss";
import Footer from "../Footer/Footer";
import ReusableTable from "./components/ReusableTable";
import "./styles/tableStyles.css";
import "./styles/Modal.scss";
import ReviewModal from "./components/Modals/ReviewModal";
import AssignModal from "./components/Modals/AssignModal";
import add from "./components/Icons/add_circle.png";
import settings from "./components/Icons/settings.png";
import search from "./components/Icons/search.png";
import up from "./components/Icons/up.png";
import review from "./components/Icons/review.png";
import SettingsIcon from "@material-ui/icons/Settings";
import {
  unassignedData,
  assignedData,
  validatedData,
} from "./components/SampleData";
import { OptionButton } from "./components/OptionButton";
import QueryToggle from "./components/QueryToggle";
import Snackbar from "@mui/material/Snackbar";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import SearchBar from "./components/SearchBar";
import EKYCHistory from "./components/ekycHistory";

class eKycTracking extends Component {
  constructor(props) {
    super(props);
    this.state = {
      revalidationCount: { count: 1 },
      showRevalidationCountButton: false,
      assignModalOpen: false,
      selectedAssignItem: null,
      reviewModalOpen: false,
      selectedReviewItem: null,
      activeButton: "unassigned",
      received_kyc_tab_nav: null,
      pending_processing_tab_nav: null,
      processed_tab_nav: null,
      isSearchVisible: false,
      selectedRows: [],
      areButtonsVisible: false,
      selectedQueries: [],
      queryAnswers: {},
      tableData: [],
      unassignedData: [],
      unassigneddData: unassignedData,
      assignedData: [],
      validatedData: [],
      unassignedCount: 0,
      assignedCount: 0,
      validatedCount: 0,
      currentPage: 0, // Track the current page for pagination
      queries: [], // Array to store queries
      queryButtonStates: {},
      editedQuestion: "",
      editMode: false,
      editedQueryId: null,
      showModal: false,
      newQueryText: "",
      showSnackbar: false,
      snackbarMessage: "",
      searchTerm: "",

      status: {
        agency_user: {
          api: "api/kyc/v1/closed-leads",
          query: [{ value: "fresh", label: "Fresh" }],
          query_reject: [{ value: "rejected", label: "Reject" }],
          body: undefined,
        },

        bkash_user: {
          api: "api/kyc/v1/list",
          query: [{ value: "bkash_qc_received", label: "bKash QC Received" }],
          body: undefined,
        },

        "bkash-super-user": {
          api: "api/kyc/v1/list",
          query: [
            {
              value: "bkash_super_user_received",
              label: "Bkash Super User Received",
            },
          ],
          body: undefined,
        },
        cluster_manager: {
          api: "api/kyc/v1/list",
          query: [
            {
              value: "bkash_qc_received",
              label: "bKash QC Received",
            },
          ],
          body: undefined,
        },
        territory_manager: {
          api: "api/kyc/v1/list",
          query: [
            {
              value: "bkash_qc_received",
              label: "bKash QC Received",
            },
          ],
          body: undefined,
        },
        area_manager: {
          api: "api/kyc/v1/list",
          query: [
            {
              value: "bkash_qc_received",
              label: "bKash QC Received",
            },
          ],
          body: undefined,
        },
        regional_manager: {
          api: "api/kyc/v1/list",
          query: [
            {
              value: "bkash_qc_received",
              label: "bKash QC Received",
            },
          ],
          body: undefined,
        },
      },
    };
  }
  handleSearch = (term) => {
    this.setState({ searchTerm: term });
  };
  onChangeRevalidationCount = (e) => {
    console.log(e.target.value);
    this.setState({ showRevalidationCountButton: true });
    this.setState((prevState) => ({
      revalidationCount: {
        ...prevState.revalidationCount,
        count: e.target.value,
      },
    }));
  };
  openModal = () => this.updateModalState(true);
  closeModal = () => this.updateModalState(false);
  updateModalState = (state) => {
    this.setState({ showModal: state, newQueryText: "" });
  };
  // Input Change methods
  handleInputChange = (e) => this.setState({ newQueryText: e.target.value });

  // Button methods
  handleButtonClick = (buttonType) =>
    this.setState({ activeButton: buttonType });

  // Review Modal methods
  openReviewModal = (item) => this.updateReviewModalState(true, item);
  closeReviewModal = () => this.updateReviewModalState(false, null);

  updateReviewModalState = (state, item) => {
    this.setState({ reviewModalOpen: state, selectedReviewItem: item });
  };

  // Assign Modal methods
  openAssignModal = (item) => this.updateAssignModalState(true, item);
  closeAssignModal = () => this.updateAssignModalState(false, null);

  updateAssignModalState = (state, item) => {
    this.setState({ assignModalOpen: state, selectedAssignItem: item });
  };

  handleBulkAssignRows = (rows) => {
    //console.log(rows);
    this.openAssignModal(rows);
  };
  addQuery = async () => {
    try {
      const newQuery = {
        question: this.state.newQueryText,
      };

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/ekyc/v1/validation-questions`,
        newQuery,
        {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
          },
        }
      );

      if (response.status === 200) {
        this.setState({ newQueryText: "" }); // Clear the new query text
        this.closeModal();
        this.fetchQueries();
      } else {
        console.error("Error adding query:", response.data);
      }
    } catch (error) {
      console.error("Error adding query:", error);
    }
  };

  fetchQueries = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/ekyc/v1/validation-questions`,
        {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
          },
        }
      );

      if (response.status === 200) {
        const queries = response.data;
        // Initialize queryButtonStates based on the data
        const queryButtonStates = {};
        queries.forEach((query) => {
          queryButtonStates[query.id] = query.is_active;
        });

        this.setState({
          queries,
          queryButtonStates, // Initialize the state with the button states
        });
      } else {
        console.error("Error fetching queries:", response.data);
      }
    } catch (error) {
      console.error("Error fetching queries:", error);
    }
  };
  handleQueryToggle = (query) => {
    const { id, question, is_active } = query;
    this.editQuery(id, question, !is_active);
    this.setState(
      {
        showSnackbar: true,
        snackbarMessage: query.is_active
          ? "Validation Question deactivated"
          : "Validation Question Activated",
      },
      () => {
        setTimeout(() => this.setState({ showSnackbar: false }), 3000); // Hide after 3 seconds
      }
    );
  };

  handleDeleteQuery = async (id, question) => {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_API_URL}/api/ekyc/v1/validation-questions`,
        {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
          },
          data: { id, question },
        }
      );

      if (response.status === 200) {
        this.fetchQueries(); // Refresh the list of queries after deleting one
      } else {
        console.error("Error deleting query:", response.data);
      }
    } catch (error) {
      console.error("Error deleting query:", error);
    }
  };

  handleQueryAnswerToggle(query) {
    const newValue = this.state.queryButtonStates?.[query] ? 0 : 1;
    this.setState({
      queryButtonStates: {
        ...this.state.queryButtonStates,
        [query]: Boolean(newValue),
      },
    });
  }

  componentDidMount() {
    this.fetchRevalidationCount();
    this.fetchQueries();
    const statuses = ["unassigned", "assigned", "validated"];
    Promise.all(
      statuses.map((status) =>
        this.fetchTableData(status, this.state.currentPage)
      )
    )
      .then((dataArray) => {
        const [unassignedData, assignedData, validatedData] = dataArray.map(
          (data) => data.data || []
        );
        const [unassignedCount, assignedCount, validatedCount] = dataArray.map(
          (data) => data.count || 0
        );
        this.setState({
          unassignedData,
          assignedData,
          validatedData,
          unassignedCount,
          assignedCount,
          validatedCount,
        });
      })
      .catch((error) => {
        console.error("Error fetching table data:", error);
      });
  }
  editQuery = async (id, question, is_active) => {
    const requestBody = {
      questions: [
        {
          id, // Question ID
          question, // The question text
          is_active, // Whether the question is active or not
        },
      ],
    };

    const url = `${process.env.REACT_APP_API_URL}/api/ekyc/v1/validation-questions`; // Removed ID from the URL

    try {
      const response = await axios.put(url, requestBody, {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
        },
      });
      if (response.status === 200) {
        console.log("Successfully updated query.");
        this.fetchQueries(); // Refresh the query list to reflect changes
      }
    } catch (error) {
      console.error("Error updating query:", error);
    }
  };

  componentDidUpdate(prevProps) {
    const localUserType = JSON.parse(localStorage.getItem("currUserType"));
    if (
      this.props.endDate !== prevProps.endDate ||
      this.props.startDate !== prevProps.startDate ||
      this.props.filterElement !== prevProps.filterElement
    ) {
      this.set_data_set();
      if (localUserType === "agency_user") {
        this.set_data_set__reject();
        this.set_data_set();
      }
    }
  }

  set_data_set = () => {
    const localUserType = JSON.parse(localStorage.getItem("currUserType"));

    let query = query_generate([
      {
        key: "team",
        values:
          this.props.filterElement.relational !== undefined
            ? this.props.filterElement.relational.team
            : [],
      },
      {
        key: "cluster_manager",
        values:
          this.props.filterElement.relational !== undefined
            ? this.props.filterElement.relational.managers
            : [],
      },
      {
        key: "territory_manager",
        values:
          this.props.filterElement.relational !== undefined
            ? this.props.filterElement.relational.managers
            : [],
      },
      {
        key: "area_manager",
        values:
          this.props.filterElement.relational !== undefined
            ? this.props.filterElement.relational.managers
            : [],
      },
      {
        key: "regional_manager",
        values:
          this.props.filterElement.relational !== undefined
            ? this.props.filterElement.relational.managers
            : [],
      },
      {
        key: "agency",
        values:
          this.props.filterElement.relational !== undefined
            ? this.props.filterElement.relational.agency
            : [],
      },
      {
        key: "tab",
        values:
          this.state.status[`${localUserType}`]["query"] !== undefined
            ? this.state.status[`${localUserType}`]["query"]
            : [],
      },
    ]);

    axios
      .get(
        `${process.env.REACT_APP_API_URL}/${
          this.state.status[`${localUserType}`]["api"]
        }?start_time=${format(
          new Date(this.props.startDate),
          "yyyy-MM-dd"
        )}&end_time=${format(
          new Date(this.props.endDate),
          "yyyy-MM-dd"
        )}&page_index=1&page_size=10${query !== "" ? "&" + query : query}`,
        {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
          },
        }
      )
      .then((res) => {
        return localUserType === "bkash-super-user";
      })
      .catch((err) => {
        console.log(err);
      });
  };

  set_data_set__reject = () => {
    const localUserType = JSON.parse(localStorage.getItem("currUserType"));

    let query = query_generate([
      {
        key: "team",
        values:
          this.props.filterElement.relational !== undefined
            ? this.props.filterElement.relational.team
            : [],
      },
      {
        key: "cluster_manager",
        values:
          this.props.filterElement.relational !== undefined
            ? this.props.filterElement.relational.managers
            : [],
      },
      {
        key: "territory_manager",
        values:
          this.props.filterElement.relational !== undefined
            ? this.props.filterElement.relational.managers
            : [],
      },
      {
        key: "area_manager",
        values:
          this.props.filterElement.relational !== undefined
            ? this.props.filterElement.relational.managers
            : [],
      },
      {
        key: "regional_manager",
        values:
          this.props.filterElement.relational !== undefined
            ? this.props.filterElement.relational.managers
            : [],
      },
      {
        key: "agency",
        values:
          this.props.filterElement.relational !== undefined
            ? this.props.filterElement.relational.agency
            : [],
      },
      {
        key: "tab",
        values:
          this.state.status[`${localUserType}`]["query_reject"] !== undefined
            ? this.state.status[`${localUserType}`]["query_reject"]
            : [],
      },
    ]);

    axios
      .get(
        `${process.env.REACT_APP_API_URL}/${
          this.state.status[`${localUserType}`]["api"]
        }?start_time=${format(
          new Date(this.props.startDate),
          "yyyy-MM-dd"
        )}&end_time=${format(
          new Date(this.props.endDate),
          "yyyy-MM-dd"
        )}&page_index=1&page_size=10${query !== "" ? "&" + query : query}`,
        {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
          },
        }
      )
      .then((res) => {
        return localUserType === "agency_user"
          ? this.setState({
              received_rejected_kyc_tab_nav: {
                image: received_kyc_img,
                active_image: received_kyc_active_img,
                name: "Rejected By bKash",
                count: res.data.rejected_count,
                index: 4,
              },
            })
          : null;
      })
      .catch((err) => {
        console.log(err);
      });
  };

  create_filter_elements = (filter, type) =>
    filter.map((item, index) => (
      <FilterElement
        key={index}
        {...item}
        selectedValue={this.props.filterElement}
        type={type}
      />
    ));

  async remove_all_filter() {
    await this.props.updateFilterElement({
      kyc_received: {
        relational: {},
        non_relational: {},
      },
    });
  }
  fetchRevalidationCount = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/ekyc/v1/revalidation-config`,
        {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
          },
        }
      );

      const data = response.data["revalidation_limit"];
      this.setState({ revalidationCount: { ...data } });
    } catch (error) {
      console.error(`Error fetching`);
    }
  };

  putRevalidationCount = async () => {
    const postBody = {
      id: this.state.revalidationCount?.id,
      count: this.state.revalidationCount?.count,
    };
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}/api/ekyc/v1/revalidation-config`,
        postBody,
        {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
          },
        }
      );

      const data = response.data.data;
      console.log(data);
      this.setState({
        showRevalidationCountButton: false,
        showSnackbar: true,
        snackbarMessage: "Maximum revalidation count configured",
      });
    } catch (error) {
      console.error(`Error fetching`);
    }
  };

  fetchTableData = async (status, currentPage) => {
    console.log("called from");
    try {
      const { pageSize } = this.state;
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/ekyc/v1/validation-lead?status=${status}&page=${currentPage}&limit=${pageSize}`,
        {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
          },
        }
      );

      const data = response.data.data;

      // Extract pagination info from the response
      const { count } = response.data;

      return { data, count };
    } catch (error) {
      console.error(
        `Error fetching table data for status ${status}, Page ${
          currentPage + 1
        }:`,
        error
      );
      return { data: [], count: 0 };
    }
  };

  fetchTableDataAndUpdateState = async (status, currentPage) => {
    try {
      const { pageSize } = this.state;
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/ekyc/v1/validation-lead?status=${status}&page=${currentPage}&limit=${pageSize}`,
        {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
          },
        }
      );

      const data = response.data.data;
      console.log(
        `Fetched Table Data for ${status}, Page ${currentPage + 1}:`,
        data
      );
      const { count } = response.data;
      this.setState({ [`${status}Data`]: data, [`${status}Count`]: count });
    } catch (error) {
      console.error(
        `Error fetching table data for status ${status}, Page ${
          currentPage + 1
        }:`,
        error
      );
    }
  };

  handleRowSelect = (rows) => {
    //console.log(rows);
  };

  render() {
    const {
      showModal,
      newQueryText,
      activeButton,
      unassignedData,
      isSearchVisible,
      queries,
      queryButtonStates,
      showSnackbar,
      snackbarMessage,
    } = this.state;
    const filteredUnassignedData = this.state.unassignedData.filter((item) => {
      return (
        item.lead_number.includes(this.state.searchTerm) ||
        item.lead_name
          .toLowerCase()
          .includes(this.state.searchTerm.toLowerCase()) ||
        item.address
          .toLowerCase()
          .includes(this.state.searchTerm.toLowerCase()) ||
        item.thana
          .toLowerCase()
          .includes(this.state.searchTerm.toLowerCase()) ||
        item.district
          .toLowerCase()
          .includes(this.state.searchTerm.toLowerCase())
      );
    });
    const filteredAssignedData = this.state.assignedData.filter((item) => {
      return (
        item.lead_number.includes(this.state.searchTerm) ||
        item.lead_name
          .toLowerCase()
          .includes(this.state.searchTerm.toLowerCase()) ||
        item.address
          .toLowerCase()
          .includes(this.state.searchTerm.toLowerCase()) ||
        item.thana
          .toLowerCase()
          .includes(this.state.searchTerm.toLowerCase()) ||
        item.district
          .toLowerCase()
          .includes(this.state.searchTerm.toLowerCase()) ||
        item.assigned_field_force__name
          .toLowerCase()
          .includes(this.state.searchTerm.toLowerCase())
      );
    });
    const filteredValidatedData = this.state.validatedData.filter((item) => {
      return (
        item.lead_number.includes(this.state.searchTerm) ||
        item.lead_name
          .toLowerCase()
          .includes(this.state.searchTerm.toLowerCase()) ||
        item.address
          .toLowerCase()
          .includes(this.state.searchTerm.toLowerCase()) ||
        item.thana
          .toLowerCase()
          .includes(this.state.searchTerm.toLowerCase()) ||
        item.district
          .toLowerCase()
          .includes(this.state.searchTerm.toLowerCase())
      );
    });

    const columnDataTypes = [
      "string", // Checkbox column
      "string", // Wallet column
      "string", // Name column
      "string", // Address column
      "string", // Thana column
      "string", // District column
      "string", // Status column
      "string", // Assigned MAO or Review column
      "string", // Action column
    ];
    const localUserToken = JSON.parse(localStorage.getItem("currUserToken"));
    if (!localUserToken) return <Redirect to="/signin" />;

    let current_time = Date.now().valueOf() / 1000;
    if (this.props.expiration < current_time) this.props.signOut();
    const columns = ["Wallet", "Name", "Agency", "Thana", "District", "Action"];

    return (
      <div className="main-container">
        <div
          className={
            JSON.parse(localStorage.getItem("currUserType")) !== "agency_user"
              ? "kyc"
              : "full-width-kyc"
          }
        >
          <div className="page-settings">
            {/* {JSON.parse(localStorage.getItem("currUserType")) !==
              "agency_user" &&
              this.props.filterHide && (
                <div
                  className="filter-container"
                  ref={(node) => {
                    this.node = node;
                  }}
                >
                  <div className="body">
                    {this.create_filter_elements(
                      relational_filter_list("kyc"),
                      "relational"
                    )}
                  </div>
                </div>
              )} */}
          </div>

          <TabNavs
            tab_navs={
              JSON.parse(localStorage.getItem("currUserType")) === "agency_user"
                ? [
                    this.state.received_rejected_kyc_tab_nav,
                    this.state.pending_processing_tab_nav,
                    this.state.processed_tab_nav,
                  ]
                : JSON.parse(localStorage.getItem("currUserType")) ===
                  "bkash_user"
                ? [this.state.processed_tab_nav]
                : JSON.parse(localStorage.getItem("currUserType")) ===
                  "cluster_manager"
                ? [this.state.processed_tab_nav]
                : JSON.parse(localStorage.getItem("currUserType")) ===
                  "territory_manager"
                ? [this.state.processed_tab_nav]
                : JSON.parse(localStorage.getItem("currUserType")) ===
                  "area_manager"
                ? [this.state.processed_tab_nav]
                : JSON.parse(localStorage.getItem("currUserType")) ===
                  "regional_manager"
                ? [this.state.processed_tab_nav]
                : [
                    this.state.received_kyc_tab_nav,
                    this.state.pending_processing_tab_nav,
                    this.state.processed_tab_nav,
                  ]
            }
          />
          <div className="options-container">
            <div className="button-options">
              <OptionButton
                label="Unassigned"
                count={this.state.unassignedCount}
                isActive={activeButton === "unassigned"}
                onClick={() => this.handleButtonClick("unassigned")}
              />
              <OptionButton
                label="Assigned"
                count={this.state.assignedCount}
                isActive={activeButton === "assigned"}
                onClick={() => this.handleButtonClick("assigned")}
              />
              <OptionButton
                label="Validated"
                count={this.state.validatedData.length}
                isActive={activeButton === "validated"}
                onClick={() => this.handleButtonClick("validated")}
              />
            </div>
            {/* <EKYCHistory /> */}
            <div style={{ display: "flex" }}>
              <SearchBar onSearch={this.handleSearch} />
              <div className="parent-container">
                <button
                  onClick={this.handleSearchButtonClick}
                  className="icon-button"
                  type="submit"
                >
                  Search
                </button>
                <button
                  className="icon-button"
                  onClick={() =>
                    this.setState({ isSearchVisible: !isSearchVisible })
                  }
                >
                  <img className="icon" src={settings} alt="Settings Icon" />
                </button>

                {isSearchVisible && (
                  <>
                    <div className="search-filter">
                      <div className="query-list ">
                        <label>Maximum revalidation count</label>
                        <div className="validation-input-container">
                          <input
                            type="number"
                            value={this.state.revalidationCount["count"]}
                            onChange={this.onChangeRevalidationCount}
                            className="revalidation-count"
                          />
                          <button
                            onClick={this.putRevalidationCount}
                            className="accept-button"
                            disabled={
                              !this.state.showRevalidationCountButton ||
                              this.state.revalidationCount.count.length === 0
                            }
                          >
                            Save
                          </button>
                        </div>
                      </div>
                      <div className="query-list">
                        <label>Validation Questions</label>
                        {queries.map((query) => (
                          <QueryToggle
                            key={query.id}
                            label={query.question}
                            is_active={query.is_active}
                            onToggle={() => this.handleQueryToggle(query)}
                            onDelete={() =>
                              this.handleDeleteQuery(query.id, query.question)
                            }
                          />
                        ))}

                        {showModal && (
                          <div className="modal">
                            <div
                              className="modal-content"
                              style={{ maxWidth: "25%", fontSize: "12px" }}
                            >
                              <input
                                type="text"
                                value={newQueryText}
                                onChange={this.handleInputChange}
                                placeholder="Type your query here"
                              />
                              <button
                                onClick={this.addQuery}
                                className="accept-button"
                              >
                                Save
                              </button>
                              <button
                                onClick={this.closeModal}
                                className="reject-button"
                              >
                                Cancel
                              </button>
                            </div>
                          </div>
                        )}
                        <button className="add-query" onClick={this.openModal}>
                          Add Query +
                        </button>
                      </div>
                    </div>
                  </>
                )}
              </div>

              {showSnackbar && (
                <Snackbar
                  open={this.state.showSnackbar}
                  autoHideDuration={6000}
                  onClose={() => this.setState({ showSnackbar: false })}
                  message={this.state.snackbarMessage}
                  action={
                    <React.Fragment>
                      {/* <Button color="secondary" size="small" onClick={() => this.setState({ showSnackbar: false })}>
                      UNDO
                    </Button> */}
                      <IconButton
                        size="small"
                        aria-label="close"
                        color="inherit"
                        onClick={() => this.setState({ showSnackbar: false })}
                      >
                        <CloseIcon fontSize="small" />
                      </IconButton>
                    </React.Fragment>
                  }
                />
              )}
            </div>
          </div>
          <div>
            {activeButton === "unassigned" && (
              <>
                <ReusableTable
                  columns={[
                    "Wallet",
                    "Name",
                    "Agency",
                    "Thana",
                    "District",
                    "Action",
                  ]}
                  data={filteredUnassignedData.map((rowData) => ({
                    Wallet: rowData.lead_number,
                    Name: rowData.lead_name,
                    District: rowData.district,
                    Thana: rowData.thana,
                    Agency: rowData.agency__name ? rowData.agency__name : "-",
                    ...rowData,
                    Action: (
                      <button
                        className="assign-button"
                        onClick={() => this.openAssignModal([rowData])}
                      >
                        <span className="plus-icon">
                          <img
                            src={add}
                            alt="Add Icon"
                            height="10px"
                            width="10px"
                          />
                        </span>{" "}
                        Assign
                      </button>
                    ),
                  }))}
                  onSelectRow={this.handleRowSelect}
                  columnDataTypes={columnDataTypes}
                  mode="unassigned"
                  handleBulkAssign={this.handleBulkAssignRows}
                />
                {this.state.assignModalOpen &&
                  this.state.selectedAssignItem && (
                    <div className="modal">
                      <div className="modal-content">
                        <AssignModal
                          isOpen={this.state.assignModalOpen}
                          onClose={this.closeAssignModal}
                          selectedAssignItem={this.state.selectedAssignItem}
                          rowDetails={this.state.selectedAssignItem}
                          fetchTableData={this.fetchTableDataAndUpdateState} // Pass the function as a prop
                        />
                        <button onClick={this.closeAssignModal}>Close</button>
                      </div>
                    </div>
                  )}
              </>
            )}

            {activeButton === "assigned" && (
              <>
                <ReusableTable
                  columns={[
                    "Wallet",
                    "Name",
                    "Agency",
                    "Thana",
                    "District",

                    "Assigned MAO",
                  ]}
                  data={filteredAssignedData.map((rowData) => ({
                    Wallet: rowData.lead_number,
                    Name: rowData.lead_name,
                    District: rowData.district,
                    Thana: rowData.thana,
                    Agency: rowData.agency__name ? rowData.agency__name : "-",
                    "Assigned MAO": (
                      <div className="assigned-mao-capsule">
                        <span
                          className="user-name"
                          style={{ fontSize: "10px" }}
                        >
                          {rowData.assigned_field_force__name}
                        </span>
                      </div>
                    ),
                  }))}
                  onSelectRow={this.handleRowSelect}
                  columnDataTypes={columnDataTypes}
                  mode="assigned"
                />
              </>
            )}

            {activeButton === "validated" && (
              <>
                <ReusableTable
                  columns={[
                    "Wallet",
                    "Name",
                    "Agency",
                    "Thana",
                    "District",
                    "Action",
                  ]}
                  data={filteredValidatedData.map((rowData) => ({
                    Wallet: rowData.lead_number,
                    Name: rowData.lead_name,
                    District: rowData.district,
                    Thana: rowData.thana,
                    Agency: rowData.agency__name ? rowData.agency__name : "-",
                    Action: (
                      <button
                        className="review-button"
                        onClick={() => this.openReviewModal(rowData)}
                      >
                        Review
                        <img
                          className="review"
                          src={review}
                          alt="Review Icon"
                        />
                      </button>
                    ),
                  }))}
                  onSelectRow={this.handleRowSelect}
                  columnDataTypes={columnDataTypes}
                />
                {this.state.reviewModalOpen &&
                  this.state.selectedReviewItem && (
                    <div className="modal">
                      <div className="modal-content">
                        <ReviewModal
                          isOpen={this.state.reviewModalOpen}
                          onClose={this.closeReviewModal}
                          selectedReviewItem={this.state.selectedReviewItem}
                          maxRevaldiationCount={
                            this.state.revalidationCount.count
                          }
                        />
                        <button onClick={this.closeReviewModal}>Close</button>
                      </div>
                    </div>
                  )}
              </>
            )}
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  let startDate = state.calendar.kyc_tracker
    ? state.calendar.kyc_tracker.startDate
    : state.calendar.kyc_default.startDate;

  let endDate = state.calendar.kyc_tracker
    ? state.calendar.kyc_tracker.endDate
    : state.calendar.kyc_default.endDate;

  let filterElement = state.filterElement.kyc
    ? state.filterElement.kyc
    : state.filterElement.default;
  let filterHide = state.filter.filterHide;
  let selectedTab = state.selectedTab.selectedTabIndex;

  let expiration = state.auth.authToken
    ? state.auth.authToken.expiration
    : 20000;

  return {
    startDate,
    endDate,
    filterElement,
    filterHide,
    selectedTab,
    expiration,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    signOut: () => dispatch(signOut()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(eKycTracking);
